import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";

import { GetTemplateList, DeleteRecords } from "../../services/CompanyService";
import { toast } from "react-toastify";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

const TemplateList = () => {
  const { t } = useTranslation();
  const [templateList, setTemplateList] = useState([]);
  const [query, setQuery] = useState("");

  const companyId = localStorage.getItem("subdomainId");

  const fetchTemplateList = () => {
    GetTemplateList()
      .then(res => {
        if (res?.status === 200) {
          let responseData = res?.data;
          responseData = decryptDataFromArray(responseData);

          setTemplateList(responseData?.data);
        }
      })
      .catch(err => {
        console.error("Error fetching department list:", err);
      });
  };

  useEffect(() => {
    fetchTemplateList();

    document.title = "NeuroTal - Template List";
  }, []);

  const handleDeleteRecords = id => {
    DeleteRecords(id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (res?.status === 200) {
          let messages = toast.success(responseData?.message);

          fetchtemplateList();
        } else {
          let messages = toast.error(responseData?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: t(`Template.id`),
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "company.company_id",
      text: t(`Template.Company Id`),
      hidden: companyId, // Hide the column if companyId exist
    },
    {
      dataField: "name",
      text: t(`Template.Template Name`),
    },

    {
      dataField: "description",
      text: t(`Template.Description`),
    },
    // {
    //   dataField: "sequence",
    //   text: t(`Template.Sequence`),
    // },
    {
      dataField: "createdAt",
      text: t(`Template.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: t(`Template.Status`),
      formatter: (cellContent, row) => (
        <>
          {row?.status == "1"
            ? t(`Location_Manager.Active`)
            : t(`Location_Manager.Inactive`)}
        </>
      ),
    },
  ];

  if (checkPermissionStatus("template-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`Template.Actions`),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/mail-template/${row.id}`}
                title={t(`Template.Edit Template Type`)}
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`Template.Edit Template`)}</span>
              </Link>
            </div>

            {/* <div className="action-one small-img">
              <div
                className="text-success blue-icon blue-color3"
                onClick={() => handleDeleteRecords(row.id)}
                style={{ cursor: "pointer" }}
                title={t(`Template.Delete Template Type`)}
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`Template.Delete`)}</span>
              </div>
            </div> */}
          </div>
        );
      },
    });
  }

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = templateList.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (templateList.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [templateList.length]);

  const renderCheck = item => {
    const searchableText = (
      item?.Template_name +
      item?.description +
      item?.sequence +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1" ? "Active" : "In Active")
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  // console.log('depart',templateList);return false;

  // if (!checkPermissionStatus("template-listt", "view")) {
  //   return (
  //     <div className="page-content">
  //       <h4 className="text-center">{t(`Template.Access Denied`)}</h4>
  //     </div>
  //   );
  // }

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Template.Template List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          {/* <div className="outerTab-box-wrapper below-vacancy amsterresign  joblist-pages-spaces"> */}
          <div className="outerTab-box-wrapper applicationcard-table">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search pbresop">
                  <div className="total-record">
                    <h5>
                      {t(`Template.Total Records`)}:{" "}
                      <span>{templateList ? templateList.length : 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <div className="serach-bar-top">
                      <form class="form-inline">
                        <input
                          class="form-control mr-sm-2"
                          type="search"
                          placeholder={t(
                            `Template.Search by name, description`
                          )}
                          aria-label="Search"
                          onChange={e => setQuery(e.target.value)}
                          title={`Please enter ${t(
                            `Template.Total Records`
                          ).toLowerCase()}`}
                        />
                        <span>
                          <img src={serach_icon} alt="search" />
                        </span>
                      </form>
                    </div>

                    <div className="tale-text right-panel mobile-arrow">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <>
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={templateList?.filter(renderCheck)}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                              wrapperClasses="table-wrapper"
                              bodyRef={tbodyRef}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TemplateList;
